// QR Kiosk v2 — KV2-7 task API class. Binds the 7 committed B5 endpoints on the
// maintenanceApiBaseUrl (same key workOrdersApi.ts uses). Normal user JWT via the
// core/api axios interceptor — nothing special to add. House style: `.then(x => x.data)`.
import api from "../../../core/api";
import { KioskTask, KioskTaskDetail, KioskTaskPhoto, KioskProgressCreated } from "./kioskTasksModels";
import { buildDoneBody, buildHoldBody, buildNoteBody } from "./taskUtils";

const getRequestConfig = () => ({ baseURL: (window as any).app.config.maintenanceApiBaseUrl });

class KioskTasksApi {
  getTasks(machineId: string): Promise<KioskTask[]> {
    return api
      .get<KioskTask[]>("/v1/kiosk/work-orders", { ...getRequestConfig(), params: { machineId } })
      .then((x) => x.data);
  }

  getTaskByNumber(number: string): Promise<KioskTaskDetail> {
    return api
      .get<KioskTaskDetail>(`/v1/kiosk/work-orders/by-number/${encodeURIComponent(number)}`, getRequestConfig())
      .then((x) => x.data);
  }

  startTask(id: string): Promise<KioskTaskDetail> {
    return api
      .post<KioskTaskDetail>(`/v1/kiosk/work-orders/${id}/start`, undefined, getRequestConfig())
      .then((x) => x.data);
  }

  holdTask(id: string, reason: string): Promise<KioskTaskDetail> {
    return api
      .post<KioskTaskDetail>(`/v1/kiosk/work-orders/${id}/hold`, buildHoldBody(reason), getRequestConfig())
      .then((x) => x.data);
  }

  resumeTask(id: string): Promise<KioskTaskDetail> {
    return api
      .post<KioskTaskDetail>(`/v1/kiosk/work-orders/${id}/resume`, undefined, getRequestConfig())
      .then((x) => x.data);
  }

  // NEVER any key other than completionNote/photos — a smuggled `cost` is a hard 400 (SEC-REQ-B5-4).
  doneTask(id: string, completionNote: string, photos: KioskTaskPhoto[]): Promise<KioskTaskDetail> {
    return api
      .post<KioskTaskDetail>(`/v1/kiosk/work-orders/${id}/done`, buildDoneBody(completionNote, photos), getRequestConfig())
      .then((x) => x.data);
  }

  // 201 KioskProgressCreated. Empty photos omit the key entirely (smaller payload, same behavior).
  addNote(id: string, text: string, photos: KioskTaskPhoto[]): Promise<KioskProgressCreated> {
    return api
      .post<KioskProgressCreated>(`/v1/kiosk/work-orders/${id}/notes`, buildNoteBody(text, photos), getRequestConfig())
      .then((x) => x.data);
  }
}

export default new KioskTasksApi();
